// extracted by mini-css-extract-plugin
export default {"fieldSet":"AddEvaluationCriteriaModal_fieldSet__F8H1d","flex":"AddEvaluationCriteriaModal_flex__nSyqk"};